export default
    {
        path: "/html",
        component: () => import('../view/html/HtmlMain.vue'),
        children: [
            {
                path: 'LeaveRequest',
                name: 'LeaveRequest',
                component: () => import('../view/html/LeaveRequest.vue')
            }
            ,
            {
              path: 'AddAttendance',
              name: 'AddAttendance',
              component: () => import('../view/html/AddAttendance.vue')
            }
            ,
            {
              path: 'Pending',
              name: 'Pending',
              component: () => import('../view/html/Pending.vue')
            },
            {
              path: 'History',
              name: 'History',
              component: () => import('../view/html/History.vue')
            },
            {
              path: 'MasterSubTable',
              name: 'MasterSubTable',
              component: () => import('../view/html/MasterSubTable.vue')
            },
            {
              path: 'Batch',
              name: 'Batch',
              component: () => import('../view/html/Batch.vue')
            },
            {
              path: 'PendingSearch',
              name: 'PendingSearch',
              component: () => import('../view/html/PendingSearch.vue')
            },
            {
              path: 'DataDictionary',
              name: 'DataDictionary',
              component: () => import('../view/html/DataDictionary.vue')
            },
            {
              path: 'foodcardindex',
              name: 'foodcardindex',
              component: () => import('../view/html/foodcard/foodcardindex.vue')
            },
            {
              path: 'foodcardRecord',
              name: 'foodcardRecord',
              component: () => import('../view/html/foodcard/foodcardRecord.vue')
            },
            {
              path: 'NewsList',
              name: 'NewsList',
              component: () => import('../view/html/NewsList.vue')
            },{
              path: 'NewsDetail',
              name: 'NewsDetail',
              component: () => import('../view/html/NewsDetail.vue')
            },{
              path: 'SystemInformation',
              name: 'SystemInformation',
              component: () => import('../view/html/SystemInformation.vue')
            },{
              path: 'NewsDetailComment',
              name: 'NewsDetailComment',
              component: () => import('../view/html/NewsDetailComment.vue')
            },{
              path: 'VacationRecord',
              name: 'VacationRecord',
              component: () => import('../view/html/VacationRecord.vue')
            },{
              path: 'ContractList',
              name: 'ContractList',
              component: () => import('../view/html/ContractList.vue')
            },{
              path: 'OfficeAssetsList',
              name: 'OfficeAssetsList',
              component: () => import('../view/html/OfficeAssetsList.vue')
            },{
              path: 'BirthdayBlessing',
              name: 'BirthdayBlessing',
              component: () => import('../view/html/BirthdayBlessing.vue')
            },{
              path: 'AnniversaryBlessing',
              name: 'AnniversaryBlessing',
              component: () => import('../view/html/AnniversaryBlessing.vue')
            },{
              path: 'BlessingList1',
              name: 'BlessingList1',
              component: () => import('../view/html/BlessingList.vue')
            },{
              path: 'DepartmentInformation',
              name: 'DepartmentInformation',
              component: () => import('../view/html/DepartmentInformation.vue')
            },{
              path: 'LendMoney',
              name: 'LendMoney',
              component: () => import('../view/html/LendMoney.vue')
            },{
              path: 'VisitorList',
              name: 'VisitorList',
              component: () => import('../view/html/visitor/VisitorList.vue')
            },{
              path: 'AssetInventory',
              name: 'AssetInventory',
              component: () => import('../view/html/AssetInventory.vue')
            },{
              path: 'InventoryList',
              name: 'InventoryList',
              component: () => import('../view/html/InventoryList.vue')
            },{
              path: 'finance',
              name: 'finance',
              component: () => import('../view/html/finance.vue')
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/htmlRouter.js